// extracted by mini-css-extract-plugin
export var wrap = "Pager-module--wrap--16h6w";
export var button = "Pager-module--button--R4-kY";
export var current = "Pager-module--current--2-Ue8";
export var leftArrow = "Pager-module--left-arrow--2Abse";
export var disabled = "Pager-module--disabled--2vT8u";